// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Therapist } from '../../../core/types';
// import { ROUTES } from '../../../core/data/routes';
// import { ShimmerAnimation, ZeroState } from '../../../core/components/ui';
// import { fetchMatchingTherapists, fetchRandomTherapists } from '../../../core/api/services';
// import { useAuthStore } from '../../auth/store/authStore';

// interface Props {
//   // keep these so IndexPage still compiles without changes
//   therapists?: Therapist[];
//   loading?: boolean;
// }

// const TherapistList: React.FC<Props> = () => {
//   const navigate = useNavigate();
//   const [search, setSearch] = useState('');
//   const [therapists, setTherapists] = useState<Therapist[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [isMatched, setIsMatched] = useState(false);
//   const user = useAuthStore(state => state.user);

// //   useEffect(() => {
// //     const load = async () => {
// //       setLoading(true);
// //       try {
// // if (!user?.id) {

// //   const random = await fetchRandomTherapists();
// //   setTherapists(random);
// //   setIsMatched(false);
// //   return;
// // }

// // const matched = await fetchMatchingTherapists(user.id);        if (matched.length > 0) {
// //           setTherapists(matched);
// //           setIsMatched(true);
// //         } else {
// //           const random = await fetchRandomTherapists();
// //           setTherapists(random);
// //           setIsMatched(false);
// //         }
// //       } catch {
// //         const random = await fetchRandomTherapists();
// //         setTherapists(random);
// //         setIsMatched(false);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     load();
// //   }, []);
// useEffect(() => {
//   const load = async () => {
//     setLoading(true);

//     try {
//       // No user -> show random therapists
//       if (!user?.id) {
//         const random = await fetchRandomTherapists();
//         setTherapists(random);
//         setIsMatched(false);
//         return;
//       }

//       // First: try to find matching therapists
//       const matched = await fetchMatchingTherapists(user.id);

//       if (matched.length > 0) {
//         // Matches found -> show ONLY matching therapists
//         setTherapists(matched);
//         setIsMatched(true);
//       } else {
//         // No matches -> show ONLY random therapists
//         const random = await fetchRandomTherapists();
//         setTherapists(random);
//         setIsMatched(false);
//       }
//     } catch (error) {
//       console.error('Error loading therapists:', error);

//       // If matching request fails, show random therapists.
//       // Never fetch all therapists here.
//       try {
//         const random = await fetchRandomTherapists();
//         setTherapists(random);
//         setIsMatched(false);
//       } catch (randomError) {
//         console.error('Error loading random therapists:', randomError);
//         setTherapists([]);
//         setIsMatched(false);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   load();
// }, [user?.id]);

//   const list = Array.isArray(therapists) ? therapists : [];
//   const filtered = list.filter(t =>
//     !search ||
//     (t.name || '').toLowerCase().includes(search.toLowerCase()) ||
//     (t.expertise || '').toLowerCase().includes(search.toLowerCase())
//   );

//   if (loading) return <TherapistSkeleton />;

//   return (
//     <div style={{ padding: '16px 16px 0' }}>
//       {/* Search bar */}
//       <div className="form-stack" style={{ position: 'relative', marginBottom: 12 }}>
//         <svg
//           style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)' }}
//           width="16" height="16" viewBox="0 0 24 24" fill="none"
//           stroke="var(--color-on-surface-variant)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
//         >
//           <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//         </svg>
//         <input
//           className="input"
//           style={{ paddingLeft: 40 }}
//           placeholder="Search therapists..."
//           value={search}
//           onChange={e => setSearch(e.target.value)}
//         />
//       </div>

//       {/* Matched label */}
//       {!search && (
//         <div style={{
//           display: 'flex', alignItems: 'center', gap: 6,
//           marginBottom: 12, paddingLeft: 2,
//         }}>
//           <div style={{
//             width: 6, height: 6, borderRadius: '50%',
//             background: isMatched ? 'var(--color-success)' : 'var(--color-on-surface-variant)',
//           }} />
//           <span style={{
//             fontSize: 11, fontWeight: 600, letterSpacing: 0.4,
//             textTransform: 'uppercase',
//             color: isMatched ? 'var(--color-success)' : 'var(--color-on-surface-variant)',
//           }}>
// {isMatched ? 'Matched for you' : 'Suggested therapists'}  </span>
//         </div>
//       )}

//       {filtered.length === 0 ? (
//         <ZeroState
//           title="No Therapists Found"
//           message={search ? 'Try a different search term.' : 'No therapists are available at the moment. Check back later.'}
//         />
//       ) : (
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
//           {filtered.map((t, i) => (
//             <TherapistCard
//               key={t.therapistId || i}
//               therapist={t}
//               onTap={() => navigate(ROUTES.DOC_SUMMARY, { state: { therapist: t } })}
//               delay={i}
//             />
//           ))}
//           <div style={{ height: 16 }} />
//         </div>
//       )}
//     </div>
//   );
// };

// // ... TherapistCard and TherapistSkeleton unchanged

// const TherapistCard: React.FC<{ therapist: Therapist; onTap: () => void; delay: number }> = ({
//   therapist, onTap, delay
// }) => {
//   const initials = (therapist.name || '').split(' ').map(n => n[0] || '').join('').slice(0, 2).toUpperCase();
//   const isAvailable = (therapist.status || '').toLowerCase() === 'available';

//   return (
//     <div
//       className="card fade-in-up"
//       onClick={onTap}
//       role="button"
//       tabIndex={0}
//       onKeyDown={e => e.key === 'Enter' && onTap()}
//       style={{
//         cursor: 'pointer',
//         animationDelay: `${delay * 0.07}s`,
//         padding: 16,
//         display: 'flex',
//         gap: 14,
//         alignItems: 'flex-start',
//         transition: 'box-shadow 0.2s, transform 0.1s',
//       }}
//       onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.99)')}
//       onMouseUp={e => (e.currentTarget.style.transform = '')}
//     >
//       {/* Avatar */}
//       <div style={{
//         width: 52, height: 52, borderRadius: '50%',
//         background: 'var(--color-primary-container)',
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//         flexShrink: 0, fontWeight: 700, fontSize: 16,
//         color: 'var(--color-on-primary-container)',
//         overflow: 'hidden',
//       }}>
//         {therapist.url ? (
//           <img src={therapist.url} alt={therapist.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//         ) : initials}
//       </div>

//       {/* Info */}
//       <div style={{ flex: 1, minWidth: 0 }}>
//         <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--color-on-surface)', marginBottom: 2 }}>
//               {therapist.name}
//             </div>
//             {therapist.expertise && (
//               <div style={{ fontSize: 12, color: 'var(--color-on-surface-variant)', marginBottom: 4 }}>
//                 {therapist.expertise}
//               </div>
//             )}
//           </div>
//           {/* Status dot */}
//           <div style={{
//             display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0,
//             padding: '3px 8px', borderRadius: 99,
//             background: isAvailable ? 'rgba(107,186,107,0.12)' : 'var(--color-surface-variant)',
//           }}>
//             <div style={{
//               width: 6, height: 6, borderRadius: '50%',
//               background: isAvailable ? 'var(--color-success)' : 'var(--color-on-surface-variant)',
//             }} />
//             <span style={{ fontSize: 11, fontWeight: 600, color: isAvailable ? 'var(--color-success)' : 'var(--color-on-surface-variant)' }}>
//               {isAvailable ? 'Available' : (therapist.status || 'Unavailable')}
//             </span>
//           </div>
//         </div>

//         <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6, flexWrap: 'wrap' }}>
//           {therapist.organization && (
//             <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
//               <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2">
//                 <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
//               </svg>
//               <span style={{ fontSize: 11, color: 'var(--color-on-surface-variant)' }}>{therapist.organization}</span>
//             </div>
//           )}
//           <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
//             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" strokeWidth="2">
//               <circle cx="12" cy="12" r="10"/><path d="M16 16s-1.5-2-4-2-4 2-4 2"/>
//               <line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/>
//             </svg>
//             <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--color-primary)' }}>
//               {therapist.rate} credit{therapist.rate !== 1 ? 's' : ''}/session
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Chevron */}
//       <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 4 }}>
//         <polyline points="9 18 15 12 9 6"/>
//       </svg>
//     </div>
//   );
// };

// const TherapistSkeleton: React.FC = () => (
//   <div style={{ padding: '16px 16px 0', display: 'flex', flexDirection: 'column', gap: 12 }}>
//     {[0, 1, 2, 3].map(i => (
//       <div key={i} className="card" style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
//         <ShimmerAnimation width={52} height={52} borderRadius="50%" />
//         <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
//           <ShimmerAnimation width="60%" height={16} />
//           <ShimmerAnimation width="40%" height={12} />
//           <ShimmerAnimation width="80%" height={12} />
//         </div>
//       </div>
//     ))}
//   </div>
// );

// export default TherapistList;
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Therapist } from '../../../core/types';
import { ROUTES } from '../../../core/data/routes';
import { ShimmerAnimation, ZeroState } from '../../../core/components/ui';
import { fetchMatchingTherapists } from '../../../core/api/services';
import { useAuthStore } from '../../auth/store/authStore';

interface Props {
  // keep these so IndexPage still compiles without changes
  therapists?: Therapist[];
  loading?: boolean;
}

const TherapistList: React.FC<Props> = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [therapists, setTherapists] = useState<Therapist[]>([]);
  const [loading, setLoading] = useState(true);
  const [noMatch, setNoMatch] = useState(false);
  const user = useAuthStore(state => state.user);

  useEffect(() => {
    const load = async () => {
      setLoading(true);

      try {
        if (!user?.id) {
          setTherapists([]);
          setNoMatch(true);
          return;
        }

        const matched = await fetchMatchingTherapists(user.id);

        if (matched.length > 0) {
          setTherapists(matched);
          setNoMatch(false);
        } else {
          setTherapists([]);
          setNoMatch(true);
        }
      } catch (error) {
        console.error('Error loading therapists:', error);
        setTherapists([]);
        setNoMatch(true);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [user?.id]);

  const list = Array.isArray(therapists) ? therapists : [];
  const filtered = list.filter(t =>
    !search ||
    (t.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (t.expertise || '').toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <TherapistSkeleton />;

  return (
    <div style={{ padding: '16px 16px 0' }}>
      {/* Search bar */}
      <div className="form-stack" style={{ position: 'relative', marginBottom: 12 }}>
        <svg
          style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)' }}
          width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="var(--color-on-surface-variant)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="input"
          style={{ paddingLeft: 40 }}
          placeholder="Search therapists..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {/* Matched label */}
      {!search && !noMatch && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 6,
          marginBottom: 12, paddingLeft: 2,
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: '50%',
            background: 'var(--color-success)',
          }} />
          <span style={{
            fontSize: 11, fontWeight: 600, letterSpacing: 0.4,
            textTransform: 'uppercase',
            color: 'var(--color-success)',
          }}>
            Matched for you
          </span>
        </div>
      )}

      {noMatch || filtered.length === 0 ? (
        <ZeroState
          title="No Matching Therapists Found"
          message={
            search
              ? 'Try a different search term.'
              : 'Update your preferences to get matched with a therapist.'
          }
        />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {filtered.map((t, i) => (
            <TherapistCard
              key={t.therapistId || i}
              therapist={t}
              onTap={() => navigate(ROUTES.DOC_SUMMARY, { state: { therapist: t } })}
              delay={i}
            />
          ))}
          <div style={{ height: 16 }} />
        </div>
      )}
    </div>
  );
};

const TherapistCard: React.FC<{ therapist: Therapist; onTap: () => void; delay: number }> = ({
  therapist, onTap, delay
}) => {
  const initials = (therapist.name || '').split(' ').map(n => n[0] || '').join('').slice(0, 2).toUpperCase();
  const isAvailable = (therapist.status || '').toLowerCase() === 'available';

  return (
    <div
      className="card fade-in-up"
      onClick={onTap}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === 'Enter' && onTap()}
      style={{
        cursor: 'pointer',
        animationDelay: `${delay * 0.07}s`,
        padding: 16,
        display: 'flex',
        gap: 14,
        alignItems: 'flex-start',
        transition: 'box-shadow 0.2s, transform 0.1s',
      }}
      onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.99)')}
      onMouseUp={e => (e.currentTarget.style.transform = '')}
    >
      {/* Avatar */}
      <div style={{
        width: 52, height: 52, borderRadius: '50%',
        background: 'var(--color-primary-container)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, fontWeight: 700, fontSize: 16,
        color: 'var(--color-on-primary-container)',
        overflow: 'hidden',
      }}>
        {therapist.url ? (
          <img src={therapist.url} alt={therapist.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : initials}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--color-on-surface)', marginBottom: 2 }}>
              {therapist.name}
            </div>
            {therapist.expertise && (
              <div style={{ fontSize: 12, color: 'var(--color-on-surface-variant)', marginBottom: 4 }}>
                {therapist.expertise}
              </div>
            )}
          </div>
          {/* Status dot */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0,
            padding: '3px 8px', borderRadius: 99,
            background: isAvailable ? 'rgba(107,186,107,0.12)' : 'var(--color-surface-variant)',
          }}>
            <div style={{
              width: 6, height: 6, borderRadius: '50%',
              background: isAvailable ? 'var(--color-success)' : 'var(--color-on-surface-variant)',
            }} />
            <span style={{ fontSize: 11, fontWeight: 600, color: isAvailable ? 'var(--color-success)' : 'var(--color-on-surface-variant)' }}>
              {isAvailable ? 'Available' : (therapist.status || 'Unavailable')}
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 6, flexWrap: 'wrap' }}>
          {therapist.organization && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span style={{ fontSize: 11, color: 'var(--color-on-surface-variant)' }}>{therapist.organization}</span>
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" strokeWidth="2">
              <circle cx="12" cy="12" r="10" /><path d="M16 16s-1.5-2-4-2-4 2-4 2" />
              <line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
            <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--color-primary)' }}>
              {therapist.rate} credit{therapist.rate !== 1 ? 's' : ''}/session
            </span>
          </div>
        </div>
      </div>

      {/* Chevron */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-on-surface-variant)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 4 }}>
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </div>
  );
};

const TherapistSkeleton: React.FC = () => (
  <div style={{ padding: '16px 16px 0', display: 'flex', flexDirection: 'column', gap: 12 }}>
    {[0, 1, 2, 3].map(i => (
      <div key={i} className="card" style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
        <ShimmerAnimation width={52} height={52} borderRadius="50%" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <ShimmerAnimation width="60%" height={16} />
          <ShimmerAnimation width="40%" height={12} />
          <ShimmerAnimation width="80%" height={12} />
        </div>
      </div>
    ))}
  </div>
);

export default TherapistList;